import React from 'react';
import { connect } from 'react-redux';
import { format2 } from './../../../../../utils/format';

const OrderRowAmount = props => {
  const { order } = props;
  return (
    <div style={{position: 'relative'}}>
      <div style={{fontSize: '12px', color: '#555'}}>
        Сумма заказа
      </div>
      <div style={{fontWeight: 'bold', fontSize: '14px'}}>{format2(order.amount)}</div>
      <div style={{fontSize: '12px'}}>руб c НДС</div>
    </div>
  );
}

export default connect()(OrderRowAmount);



// WEBPACK FOOTER //
// ./src/components/layout/content/orders/order-row-confirmed/amount.js